import { render, staticRenderFns } from "./connect.vue?vue&type=template&id=b9fc95cc&scoped=true"
import script from "./connect.vue?vue&type=script&lang=js"
export * from "./connect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fc95cc",
  null
  
)

export default component.exports